export default {
	liza: '/images/clients/liza/camp_liza_logotip_final.svg',
};
